import styles from "./specialProduct.module.scss";
import { Row, Col, useRouter } from "../../atoms/DependencyHelper";
import HotSpot from "../../molecules/hotSpot/HotSpot";
import Tag from "../../atoms/tag/Tag";
import { createMarkup, goToUrl } from "../../../utils/helperServices";
import PropTypes from "prop-types";
import CTAButton from "../../atoms/CTAButton/CTAButton";

const SpecialProduct = (props) => {
	const router = useRouter();
	const handleClick = () => {
		goToUrl(props.ctaLink, router);
	};

	return (
		<div className={`${styles.card} ${props.className}`} id={props.id} data-cms-title={props["data-cms-title"]}>
			<div className={styles["card__media"]}>
				<HotSpot imgUrl={props.imgUrl} dataPoints={props.hotSpots} />
				{props.tagLabel && <Tag variant={props.tagVariant} className={styles.tag} label={props.tagLabel} />}
			</div>
			<div className={styles["card-bottom-container"]}>
				<div className={styles["card__body"]}>
					<div className={styles["card__title"]}>{props.heading}</div>
					<div className={styles["card__description"]} dangerouslySetInnerHTML={createMarkup(props.description)} />
					<div className={styles["card__label"]}>{props.additionals}</div>
				</div>
				<div className={styles["card__footer"]}>
					<div>
						<span className={styles["card__price"]}>
							{props.price} {}
						</span>
					</div>
					<div  className="text-right ml-xs">
						<CTAButton className={`${styles["card__cta1"]}`} url={props.ctaLink} variant={props.variant} id={`${props.id}_CTABtn`} isOpenNewTab={props?.isOpenNewTab}>
							{props.ctaLabel}
						</CTAButton>
					</div>
				</div>
			</div>
		</div>
	);
};

SpecialProduct.defaultProps = {
	type: "image",
	className: "",
	variant:""
};
SpecialProduct.propTypes = {
	heading: PropTypes.string,
	description: PropTypes.string,
	imgUrl: PropTypes.string,
	videoUrl: PropTypes.string,
	additionals: PropTypes.string,
	hotSpots: PropTypes.array,
	price: PropTypes.string,
	ctaLabel: PropTypes.string,
	ctaLink: PropTypes.string,
	type: PropTypes.oneOf([ "image", "video", "hotspot" ]),
	label: PropTypes.string,
	tagVariant: PropTypes.string,
	tagLabel: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	"data-cms-title": PropTypes.string,
	variant: PropTypes.string
};

export default SpecialProduct;
